/**
 * src/components/ui/Pagination.jsx — page controls.
 *
 * A real `<nav aria-label="Pagination">`, per REDESIGN.md's landmarks
 * requirement — a page's own `<main>` may hold several navigable groups
 * (a data table's pagination is one), so it needs its own label to be
 * distinguishable from the app's primary navigation in a landmarks list.
 */

/**
 * @param {{ page: number, pageCount: number, onChange: (page: number) => void }} props
 * @returns {JSX.Element|null}
 */
export function Pagination({ page, pageCount, onChange }) {
  if (pageCount <= 1) return null;
  return (
    <nav className="ui-pagination" aria-label="Pagination">
      <button type="button" className="btn btn-sm" disabled={page <= 1} onClick={() => onChange(page - 1)}>
        Previous
      </button>
      <span className="ui-pagination-status" aria-current="page">
        Page {page} of {pageCount}
      </span>
      <button
        type="button"
        className="btn btn-sm"
        disabled={page >= pageCount}
        onClick={() => onChange(page + 1)}
      >
        Next
      </button>
    </nav>
  );
}
